import Vue from 'vue'
import Vuex from 'vuex'
import app from '../../main'
import checkResponse from '@/utils/checkResponse'
import axios from 'axios'
import Crud from '../crud'
const model = (payload) => ({
  // columns
  id: payload.id
})
var crud = new Crud('SupplierPayments', model)

Vue.use(Vuex)

const state = {
  ...crud.state,
  supplierPayments: []
}

const mutations = {
  ...crud.mutations
}

const actions = {
  ...crud.actions,
  async addPayment ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.post(`supplier-payments`, payload)
      const checkErrors = checkResponse(response)
      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.' + 'payments', text: 'front.added_successfully', icon: 'checkmark-circle-outline' }, { root: true })
        commit('SupplierInvoices/UPDATE_RECORD', response.data.data, { root: true })
        commit('SupplierInvoices/SET_INVOICE', { invoice: response.data.data }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async deletePayment ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.delete(`supplier-payments/${payload.id}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('DELETE_RECORD', payload)
        commit('SupplierInvoices/UPDATE_RECORD', response.data, { root: true })
        commit('SupplierInvoices/SET_INVOICE', { invoice: response.data }, { root: true })
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.payment', text: 'front.deleted_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  }
}

const getters = {
  ...crud.getters,
  supplierPayments: state => state.supplierPayments,
  supplierInvoice: (state, getters, rootState, rootGetters) => rootGetters['SupplierInvoices/supplierInvoice']
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
